import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'nav-item-categoria',
  templateUrl: 'navitem.categoria.html',
  styleUrls:['navitem.categoria.css']
})
export class NavitemCategoria implements OnInit {
  @Output() click = new EventEmitter();
  fimg = null;
  ftext = '';
  fvalue:any = {};
  findex = -1;
  finfo ="";
  fvisible = true;
  fCategoria:string;

  @Input()
  get categoria(){
    return this.fCategoria;
  }
  set categoria(x){
     this.fCategoria = x;
     console.log(x);
  }

  constructor() { }

  ngOnInit() {
  }

  doClick(item) {
    console.log(item);
    if (item != null) {
      this.click.emit(item)
    } else
      this.click.emit(this.fvalue);
  }

  getImage(){
    if (this.fimg>""){
    return this.fimg;
    } else  return '';
  }

  getImagePath(){
     return this.fvalue.imgSrc; 
  }

  @Input()
  get hasImage(){
    return this.fimg>"";
  }

  @Input()
  get text() {
    return this.ftext;
  }
  set text(v) {
    this.ftext = v;
  }

  @Input()
  get value() {
    return this.fvalue;
  }
  set value(v:any) {
    this.fvalue = v;
  }
  @Input()
  get index() {
    return this.findex;
  }
  set index(v) {
    this.findex = v;
  }
  
  @Input()
  get img(){
   return this.fimg;
  }
  set img(x){
    this.fimg = x;
  }

  @Input()
  get info(){
    return this.finfo;
  }
  set info(v){
    this.finfo = v;
  }

  showInfo() {
    alert(this.finfo);
  }
  
  @Input()
  get visible(){
    return this.fvisible;
  }
  set visible(v){
    this.fvisible = v;
  }

}
